"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* globals craeft */
var tickable_1 = __importDefault(require("./tickable"));
var mathjs_1 = require("mathjs");
var rand_1 = require("./tools/rand");
var config_1 = __importDefault(require("../config"));
var Organism = /** @class */ (function (_super) {
    __extends(Organism, _super);
    function Organism(_a) {
        var _b = _a === void 0 ? {
            name: 'Organism'
        } : _a, name = _b.name, sta = _b.sta, hp = _b.hp;
        var _this = _super.call(this) || this;
        _this.dead = false;
        _this.isFarming = false;
        _this.id = rand_1.getRandomId();
        _this.level = 1;
        _this.name = name;
        _this.expCurrent = 0;
        _this.expMax = config_1.default.organismInitialRequiredExp;
        _this.staCurrent = sta ? sta : 0;
        _this.staMax = sta ? sta : 0;
        _this.hpCurrent = hp ? hp : 0;
        _this.hpMax = hp ? hp : 0;
        return _this;
    }
    Organism.prototype.levelUp = function () {
        this.level++;
        this.expMax = Math.floor(this.expMax + (50 * mathjs_1.log(this.level, 10)));
        global.craeft.logs.push("\"" + this.name + "\" has reached Level " + this.level);
    };
    Organism.prototype.addExp = function (exp) {
        if (!this.dead) {
            if (this.expCurrent + exp >= this.expMax) {
                var nextExp = this.expCurrent + exp - this.expMax;
                // level up
                this.expCurrent = 0;
                this.levelUp();
                this.addExp(nextExp);
            }
            else {
                this.expCurrent += exp;
            }
        }
    };
    Organism.prototype.exhaust = function (sta) {
        this.staCurrent -= sta;
        if (this.staCurrent < 0) {
            this.staCurrent = 0;
        }
    };
    Organism.prototype.takeDamage = function (dmg) {
        this.hpCurrent -= dmg;
        global.craeft.logs.push(this.name + " has taken " + Math.floor(dmg) + " Damage!");
        if (Math.floor(this.hpCurrent) <= 0) {
            // killed
            this.hpCurrent = 0;
            this.dead = true;
        }
        return this.dead;
    };
    Organism.prototype.tick = function (tick) {
        // stub please override
    };
    return Organism;
}(tickable_1.default));
exports.default = Organism;
